import React from "react"
import Subtitle from "../../components/Subtitle";
import {Box, Grid, Typography} from "@mui/material";
import {useTranslation} from "react-i18next";
import {getCurrentLanguage} from "../../utils/Helpers";

const EcosystemLayout = () => {
    const {t,i18n} = useTranslation();
    let key = getCurrentLanguage(i18n);
    return (
        <React.Fragment>
            <Box component="main">
                <Subtitle/>
                <br/>
                <br/>
                <Typography variant="h4" style={{fontWeight: "bold"}}>
                    {t('ecosystem_page.title' as any)}
                </Typography>
                <br/>
                <Typography paragraph>
                    {t('ecosystem_page.paragraph_1' as any)}
                </Typography>
                <Typography paragraph>
                    {t('ecosystem_page.paragraph_2' as any)}
                </Typography>
                <Typography paragraph>
                    {t('ecosystem_page.paragraph_3' as any)}
                </Typography>
                {/* 1. Section*/}
                <Grid container>
                    <Typography variant="h5" style={{fontWeight: "bold"}}>
                        {t('ecosystem_page.section_1_title' as any)}
                    </Typography>
                    <Typography paragraph>
                        {t('ecosystem_page.section_1_paragraph_1' as any)}
                    </Typography>
                    <Typography paragraph>
                        {t('ecosystem_page.section_1_paragraph_2' as any)}
                    </Typography>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_1_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb1-Biomassezuwachs.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_1_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_2_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 2"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb2-CO2-Fixierung.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_2_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_3_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 2"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb3-Abfluss.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_3_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_4_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 2"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb4-Wasserverbrauch.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_4_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_5_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 2"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb5-Kuehlungsenergie.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_5_description' as any)}
                        </Typography>
                    </Grid>
                </Grid>
                {/* 2. Section*/}
                <Grid container>
                    <Typography variant="h5" style={{fontWeight: "bold"}}>
                        {t('ecosystem_page.section_2_title' as any)}
                    </Typography>
                    <Typography paragraph>
                        {t('ecosystem_page.section_2_description' as any)}
                    </Typography>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_6_title' as any)}
                        </Typography>
                        <Grid container>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Winterlinde.png")}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Buche.png")}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Rosskastanie.png")}
                                />
                            </Grid>
                        </Grid>
                        <Grid container>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Robinie.png")}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Platane.png")}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Box
                                    sx={{maxWidth: "80%"}}
                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb6-Eiche.png")}
                                />
                            </Grid>
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_6_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.section_2_paragraph_1' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_2_paragraph_2' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_7_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb7-Biomasse-Robinie-Winterlinde.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_7_description' as any)}
                        </Typography>

                        <Typography paragraph>
                            {t('ecosystem_page.section_2_paragraph_3' as any)}
                        </Typography>


                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_8_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb8-Biomassezuwachs-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_8_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_9_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb9-CO2Fixierung-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_9_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_10_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb10-Abfluss-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_10_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_11_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb11-Kuehlung-Robinie-Winterlinde.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_11_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_12_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb12-Kuehlung-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_12_description' as any)}
                        </Typography>
                    </Grid>
                </Grid>
                {/* 3. Section*/}
                <Grid container>
                    <Typography variant="h5" style={{fontWeight: "bold"}}>
                        {t('ecosystem_page.section_3_title' as any)}
                    </Typography>
                    <br/>
                    <br/>
                    <Grid container>
                        <Typography variant="h6" style={{fontWeight: "bold"}}>
                            {t('ecosystem_page.section_3_subtitle_1' as any)}
                        </Typography>
                        <br/>
                        <br/>
                        <Grid container>
                            <Typography paragraph>
                                {t('ecosystem_page.diagram_13_title' as any)}
                            </Typography>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Box

                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb13-Pflanzen-Bodenwasserspeicher-Biomasse-Muc-Wzbg.png")}
                                />
                            </Grid>
                            <Typography style={{
                                alignItems: "center",
                                color: "gray",
                                marginTop: 4,
                                textAlign: "center",
                                justifyContent: "center"
                            }}
                                        paragraph>
                                {t('ecosystem_page.diagram_13_description' as any)}
                            </Typography>
                        </Grid>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_13_description_2' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_14_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb14-Pflanzen-Bodenwasserspeicher-Transp-Muc-Wzbg.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_14_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_15_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb15-Pflanzen-Bodenwasserspeicher-Kuehlung-Muc-Wzbg.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_15_description' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_15_description_2' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography variant="h6" style={{fontWeight: "bold"}}>
                            {t('ecosystem_page.section_3_subtitle_2' as any)}
                        </Typography>
                        <br/>
                        <br/>
                        <Grid container>
                            <Typography paragraph>
                                {t('ecosystem_page.diagram_16_title' as any)}
                            </Typography>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Box

                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb16-Bodenversiegelung-Biomasse-Muc-Wzbg.png")}
                                />
                            </Grid>
                            <Typography style={{
                                alignItems: "center",
                                color: "gray",
                                marginTop: 4,
                                textAlign: "center",
                                justifyContent: "center"
                            }}
                                        paragraph>
                                {t('ecosystem_page.diagram_16_description' as any)}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_17_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb17-Bodenversiegelung-Transp-Abfluss-Muc-Wzbg.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_17_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.section_3_paragraph_1' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_3_paragraph_2' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_18_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb18-Bodenversiegelung-Kuehlung-Transp-Muc-Wzbg.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_18_description' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_3_paragraph_3' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography variant="h6" style={{fontWeight: "bold"}}>
                            {t('ecosystem_page.section_3_subtitle_3' as any)}
                        </Typography>
                        <br/>
                        <br/>
                        <Grid container>
                            <Typography paragraph>
                                {t('ecosystem_page.diagram_19_title' as any)}

                            </Typography>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Box

                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb19-Horizont-Biomasse.png")}
                                />
                            </Grid>
                            <Typography style={{
                                alignItems: "center",
                                color: "gray",
                                marginTop: 4,
                                textAlign: "center",
                                justifyContent: "center"
                            }}
                                        paragraph>
                                {t('ecosystem_page.diagram_19_description' as any)}
                            </Typography>
                            <Typography paragraph>
                                {t('ecosystem_page.section_3_paragraph_4' as any)}
                            </Typography>
                            <Typography paragraph>
                                {t('ecosystem_page.diagram_20_title' as any)}
                            </Typography>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Box

                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb20-Horizont-Tranps-Abfluss.png")}
                                />
                            </Grid>
                            <Typography style={{
                                alignItems: "center",
                                color: "gray",
                                marginTop: 4,
                                textAlign: "center",
                                justifyContent: "center"
                            }}
                                        paragraph>
                                {t('ecosystem_page.diagram_20_description' as any)}
                            </Typography>
                            <Typography paragraph>
                                {t('ecosystem_page.section_3_paragraph_5' as any)}
                            </Typography>
                            <Typography paragraph>
                                {t('ecosystem_page.diagram_21_title' as any)}
                            </Typography>
                            <Grid container alignItems='center' justifyContent='center'>
                                <Box

                                    component="img"
                                    alt="Table Sealing 1"
                                    src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb21-Horizont-Kuehlung-Transp.png")}
                                />
                            </Grid>
                            <Typography style={{
                                alignItems: "center",
                                color: "gray",
                                marginTop: 4,
                                textAlign: "center",
                                justifyContent: "center"
                            }}
                                        paragraph>
                                {t('ecosystem_page.diagram_21_description' as any)}
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                {/* 4. Section */}
                <Grid container>
                    <Typography variant="h5" style={{fontWeight: "bold"}}>
                        {t('ecosystem_page.section_4_title' as any)}
                    </Typography>
                    <br/>
                    <br/>
                    <Typography paragraph>
                        {t('ecosystem_page.section_4_paragraph_1' as any)}

                    </Typography>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_22_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box

                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb22-Klima-CO2Fixierung-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_22_description' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_4_paragraph_2' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_4_paragraph_3' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_23_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb23-Klima-Kuehlwirkung-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_23_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.section_4_paragraph_4' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_4_paragraph_5' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_24_title' as any)}
                        </Typography>
                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb24-Klima-Wasserverbrauch-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_24_description' as any)}
                        </Typography>
                    </Grid>
                    <Grid container>
                        <Typography paragraph>
                            {t('ecosystem_page.diagram_25_title' as any)}
                        </Typography>

                        <Grid container alignItems='center' justifyContent='center'>
                            <Box
                                component="img"
                                alt="Table Sealing 1"
                                src={require("../../assets/pages/detail/ecosystem/"+key+"/Abb25-Klima-Abfluss-Muc-Berlin.png")}
                            />
                        </Grid>
                        <Typography style={{
                            alignItems: "center",
                            color: "gray",
                            marginTop: 4,
                            textAlign: "center",
                            justifyContent: "center"
                        }}
                                    paragraph>
                            {t('ecosystem_page.diagram_25_description' as any)}
                        </Typography>
                        <Typography paragraph>
                            {t('ecosystem_page.section_4_paragraph_6' as any)}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </React.Fragment>
    )
}
export default EcosystemLayout
